export const ultiuberDevices = require("./ultiuber_overlay-fs8.png");
export const ultiuberShellsLogo = require("./ultiuber_white_shells.png");
